import { useEffect, useState, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import MainNavigation from './layout/MainNavigation/MainNavigation';
import MobileBlocker from './components/MobileBlocker/MobileBlocker';
import MainContent from './layout/MainContent/MainContent';
import MainTabs from './layout/MainTabs/MainTabs';
import SnackbarInfo from './components/Snackbar/Snackbar';
import SignIn from './pages/SignIn/SignIn';
import { useAuth } from './store/authAtom';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import { BackdropSx, StickyHeaderSx } from './AppProps';
import {
  MainLinks,
  preloadEditClient,
  preloadEditTask,
} from './layout/MainNavigation/MainNavigationUtils';
import React from 'react';
import ProtectedRoute from './router/ProtectedRoute/ProtectedRoute';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import NotFoundRoute from './router/ProtectedRoute/NotFoundRoute';
import CoreEntityMissingDialog from './components/CoreEntityMissingDialog/CoreEntityMissingDialog';
import { loadTableFeaturesAndPreferences } from './apiClient/userPreferences';

function App() {
  const checkIsMobile = () => {
    return (
      /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(
        navigator.userAgent
      ) || window.matchMedia('(max-width: 768px)').matches
    );
  };

  const [isMobile, setIsMobile] = useState(checkIsMobile);
  const { authState } = useAuth();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(checkIsMobile());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    loadTableFeaturesAndPreferences();
    preloadEditClient();
    preloadEditTask();
  }, []);

  if (isMobile) {
    return <MobileBlocker />;
  }

  if (authState.whoAmILoading) {
    return (
      <Backdrop sx={BackdropSx} open={true}>
        <CircularProgress color="inherit" size={50} />
      </Backdrop>
    );
  }

  return (
    <>
      <Routes>
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/create-new-password" element={<ResetPassword />} />
        <Route
          path={'/'}
          element={
            <ProtectedRoute isLoggedIn={Boolean(authState.user)}>
              <Box sx={StickyHeaderSx}>
                <MainNavigation />
                <MainTabs />
              </Box>
              <MainContent />
            </ProtectedRoute>
          }
        >
          {Object.entries(MainLinks).map(([_, link]) => (
            <Route
              key={link.title}
              path={link.url}
              element={
                <Suspense
                  fallback={
                    <Backdrop sx={BackdropSx} open={true}>
                      <CircularProgress color="inherit" size={50} />
                    </Backdrop>
                  }
                >
                  {React.createElement(link.component)}
                </Suspense>
              }
            />
          ))}
        </Route>
        <Route path="*" element={<NotFoundRoute />} />
      </Routes>
      <SnackbarInfo />
      <CoreEntityMissingDialog />
    </>
  );
}

export default App;
